module.exports = __webpack_public_path__ + "static/img/us.e62078b.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/aboutsUs/us.jpeg
// module id = K8yC
// module chunks = 1